export interface PackCartFields {
  id: string;
  school?: string;
  date?: string;
  files?: string[];
}

export function isPackItem(item: Pick<PackCartFields, 'id'>): boolean {
  return item.id.startsWith('pack_');
}

export function packSessionKey(item: PackCartFields): string {
  return `${(item.school || '').trim().toLowerCase()}::${(item.date || '').trim()}`;
}

/** Solo fusionar si es la misma búsqueda repetida (un pack contiene al otro). */
export function packsShouldMerge(a?: string[], b?: string[]): boolean {
  if (!a?.length || !b?.length) return false;
  const setB = new Set(b);
  const intersection = a.filter((file) => setB.has(file)).length;
  if (intersection === 0) return false;
  const minLen = Math.min(a.length, b.length);
  return intersection >= minLen;
}

/** Índice del pack fusionable (misma sesión y casi las mismas fotos). */
export function findMergeablePackIndex<T extends PackCartFields>(
  items: T[],
  item: T,
): number {
  if (!isPackItem(item)) return -1;
  const key = packSessionKey(item);
  return items.findIndex(
    (candidate) =>
      isPackItem(candidate) &&
      packSessionKey(candidate) === key &&
      packsShouldMerge(candidate.files, item.files),
  );
}

export function mergePackFiles(a?: string[], b?: string[]): string[] | undefined {
  const merged = [...(a || []), ...((b || []))];
  if (merged.length === 0) return a || b;
  return Array.from(new Set(merged));
}

export function newPackCartId(school?: string, date?: string): string {
  const schoolPart = (school || 'pack').trim().replace(/\s+/g, '_');
  const datePart = (date || 'all').trim() || 'all';
  return `pack_${schoolPart}_${datePart}_${Date.now()}`;
}
